module.exports = __webpack_public_path__ + "img/80014.c3109331.png";